import React from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

export const CalendarioSeleccion = ({ mostrarCalendario, fechaSeleccionadas, handleSelect, eliminarFecha }) => {
    return (
        <div className="border rounded p-4 shadow-sm bg-light">
            <h4 className="mb-3 text-dark font-weight-bold">Calendario seleccionar fechas.</h4>
            <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ flex: 2 }}>
                    {mostrarCalendario && (
                        <div
                            style={{
                                width: "100%",
                                maxWidth: "300px",
                                margin: "0 auto",
                            }}
                        >
                            <DayPicker
                                mode="multiple"
                                selected={fechaSeleccionadas}
                                onSelect={handleSelect}
                                styles={{
                                    caption: {
                                        textAlign: "center",
                                        fontSize: "0.9rem",
                                    },
                                    day: {
                                        width: "2rem",
                                        height: "2rem",
                                        fontSize: "0.8rem",
                                    },
                                }}
                            />
                        </div>
                    )}
                </div>

                <div style={{ flex: 3 }}>
                    {fechaSeleccionadas.length === 0 ? (
                        <p>No se han seleccionado fechas.</p>
                    ) : (
                        mostrarCalendario && (
                            <div
                                style={{
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                    border: "1px solid #ddd",
                                    borderRadius: "5px",
                                    padding: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(3, 1fr)",
                                        gap: "10px",
                                    }}
                                >
                                    {[...fechaSeleccionadas]
                                        .sort((a, b) => a - b)
                                        .map((fecha, idx) => (
                                            <div
                                                key={idx}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "5px",
                                                    padding: "10px",
                                                    backgroundColor: "#f9f9f9",
                                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                                                }}
                                            >
                                                <span>{fecha.toLocaleDateString("es-ES")}</span>
                                                <button
                                                    type="button"
                                                    className="btn avtar avtar-xs btn-light-danger me-1"
                                                    onClick={() => eliminarFecha(fecha)}
                                                    style={{
                                                        background: "transparent",
                                                        border: "none",
                                                        cursor: "pointer",
                                                        color: "red",
                                                    }}
                                                >
                                                    <i className="ti ti-x"></i>
                                                </button>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};
